import type { Map } from "mapbox-gl";

import locationPinUrl from "components/PlotMap/utils/locationPin.svg";

export const LOCATION_CLUSTER_MAX_ZOOM = 12;
export const LOCATION_CLUSTER_RADIUS = 30;
export const LOCATION_PIN_IMAGE_ID = "location-pin";
export const PIN_WIDTH = 26;
export const PIN_HEIGHT = 38;

const PIN_PIXEL_RATIO = 2;

const loadLocationPinImage = (): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image(
      PIN_WIDTH * PIN_PIXEL_RATIO,
      PIN_HEIGHT * PIN_PIXEL_RATIO,
    );
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = locationPinUrl;
  });

export const addLocationPinImage = async (map: Map): Promise<void> => {
  if (map.hasImage(LOCATION_PIN_IMAGE_ID)) {
    return;
  }
  const image = await loadLocationPinImage();
  if (!map.isStyleLoaded() || map.hasImage(LOCATION_PIN_IMAGE_ID)) {
    return;
  }
  map.addImage(LOCATION_PIN_IMAGE_ID, image, { pixelRatio: PIN_PIXEL_RATIO });
};
